export type QuoteType =
  | 'print-renewal'
  | 'email-offer'
  | 'print-offer'
  | 'email-renewal'
  | 'dg-offer'
  | 'dg-renewal'
  | 'jl-offer'
  | 'jl-renewal';
